function setMobileHeaderHeight() {
  var header = document.querySelector('.header-kaj .header-area');
  if (!header) return;
  document.documentElement.style.setProperty('--mobile-header-height', header.offsetHeight + 'px');
}

var filterDrawerMobileMq = window.matchMedia('(max-width: 991px)');

function getFilterDrawer() {
  return $('.filter-sidebar').first();
}

function getFilterDrawerPortalTarget() {
  var $header = $('.header-kaj');
  return $header.length ? $header : $('body');
}

function portalFilterDrawer() {
  if (!filterDrawerMobileMq.matches) return;

  var $filter = getFilterDrawer();
  if (!$filter.length || $filter.data('portal-attached')) return;

  $filter.data('portal-placeholder', $('<div class="filter-sidebar-placeholder" aria-hidden="true"></div>'));
  $filter.before($filter.data('portal-placeholder'));
  getFilterDrawerPortalTarget().append($filter);
  $filter.data('portal-attached', true);
}

function restoreFilterDrawer() {
  var $filter = getFilterDrawer();
  if (!$filter.length || !$filter.data('portal-attached')) return;

  var $placeholder = $filter.data('portal-placeholder');
  if ($placeholder && $placeholder.length) {
    $placeholder.replaceWith($filter);
  }

  $filter.removeClass('active');
  $filter.removeData('portal-attached portal-placeholder');
}

function openFilterDrawer() {
  setMobileHeaderHeight();
  portalFilterDrawer();
  $(".main-menu-area").removeClass("active");
  getFilterDrawer().addClass("active");
  $(".mm-fullscreen-bg").addClass("active");
  $("body").addClass("hidden");
}

function closeFilterDrawer() {
  getFilterDrawer().removeClass("active");
  $(".mm-fullscreen-bg").removeClass("active");
  $("body").removeClass("hidden");
}

$(window).on('load', function() {
  "use strict";
  $('.megamenu-li').parent('.container').parent('ul').addClass('mega-menu');
  $('.banner-wrap').parent('.container').parent('ul').addClass('bottom-banner');
  $('.menu-banner').parent('.container').parent('ul').addClass('banner-menu');
  $('.submenu-li').parent('.container').parent('ul').addClass('sub-menu');

  var popup = localStorage.getItem('popup_value');
  if(popup != 1){
    $('#news-letter-modal').modal('show');
  }

  $('#popup-close').on('click',function(){
      localStorage.setItem('popup_value', '1');
  });
  $("button.navbar-toggle").on('click', function() {
    closeFilterDrawer();
    $(".main-menu-area").addClass("active");
    $(".mm-fullscreen-bg").addClass("active");
    $("body").addClass("hidden");
  });

  $(".close-box").on('click', function() {
    $(".main-menu-area").removeClass("active");
    $(".mm-fullscreen-bg").removeClass("active");
    $("body").removeClass("hidden");
  });

  function openMiniCart() {
    if (typeof window.technixiaHideAllTooltips === 'function') {
      window.technixiaHideAllTooltips();
    }
    $(".mini-cart").addClass("show");
    $(".mm-fullscreen-bg").addClass("active");
    $("body").addClass("hidden");
  }

  function closeMiniCart() {
    $(".mini-cart").removeClass("show");
    $(".mm-fullscreen-bg").removeClass("active");
    $("body").removeClass("hidden");
  }

  $(".shopping-cart a.cart-count").on('click', function() {
    if (typeof window.technixiaRefreshMiniCart === 'function') {
      window.technixiaRefreshMiniCart(openMiniCart);
    } else {
      openMiniCart();
    }
  });

  $(document).on('click', '.shopping-cart-close, .shopping-cart-close i', function() {
    closeMiniCart();
  });

  $(".ajax-spin-cart").on('click', function() {
    if (typeof window.technixiaHideAllTooltips === 'function') {
      window.technixiaHideAllTooltips();
    }
    $(this).blur();

    if ($(this).closest('.product-details-page').length) {
      return;
    }

    window.setTimeout(function() {
      if (typeof window.technixiaRefreshMiniCart === 'function') {
        window.technixiaRefreshMiniCart(openMiniCart);
      } else {
        openMiniCart();
      }
    }, 1000);
  });

  setMobileHeaderHeight();
  $(window).on('resize orientationchange', function() {
    setMobileHeaderHeight();
    if (!filterDrawerMobileMq.matches) {
      restoreFilterDrawer();
    }
  });

  // filter button js
  $("button.filter-button").on('click', function() {
    openFilterDrawer();
  });

  $("button.close-filter-sidebar").on('click', function() {
    closeFilterDrawer();
  });

  $(".mm-fullscreen-bg").on('click', function() {
    $(".mini-cart").removeClass("show");
    $(".main-menu-area").removeClass("active");
    closeFilterDrawer();
  });

  window.initWishlistTooltips = function (root) {
    var scope = root || document;
    scope.querySelectorAll('.wishlist-btn[data-bs-toggle="tooltip"]').forEach(function (el) {
      var existing = bootstrap.Tooltip.getInstance(el);
      if (existing) {
        existing.dispose();
      }

      var tip = new bootstrap.Tooltip(el, {
        trigger: 'hover',
        customClass: 'wishlist-tooltip'
      });

      el.addEventListener('mouseleave', function () {
        tip.hide();
      });

      el.addEventListener('click', function () {
        tip.hide();
        el.blur();
      });
    });
  };

  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]:not(.wishlist-btn)'));
  tooltipTriggerList.map(function (tooltipTriggerEl) {
    var tip = new bootstrap.Tooltip(tooltipTriggerEl);
    tooltipTriggerEl.addEventListener('click', function () {
      tip.hide();
      tooltipTriggerEl.blur();
    });
    return tip;
  });

  window.initWishlistTooltips();

  if ($.fn.magnificPopup) {
    $('.play-button, .popup-vimeo, .popup-gmaps').magnificPopup({
      tClose: 'Close (Esc)',
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    });
  }

      
  $('#top').on('click', function() {
    $("html, body").animate({ scrollTop: 0 }, 0);
    return false;
    });
  });

  function updateStickyHeader() {
    var sticky = $('.header-area'),
    scroll = $(window).scrollTop();
    if (scroll >= 50) {
      sticky.addClass('is-sticky');
    } else {
      sticky.removeClass('is-sticky');
    }
    setMobileHeaderHeight();
  }

  updateStickyHeader();

  $(window).scroll(function(){
    if ($(this).scrollTop() > 1000) {
      $('#top').fadeIn();
    } else {
      $('#top').fadeOut();
    }

    updateStickyHeader();
  });

(function initProductMobileImageSwap() {
  if (!window.matchMedia('(max-width: 1199px)').matches) return;

  function clearAltImages(except) {
    document.querySelectorAll('.single-product-wrap.is-alt-image').forEach(function(wrap) {
      if (wrap !== except) wrap.classList.remove('is-alt-image');
    });
  }

  document.addEventListener('touchstart', function(e) {
    var link = e.target.closest('.single-product-wrap .pro-img');
    if (!link) {
      clearAltImages(null);
      return;
    }

    var wrap = link.closest('.single-product-wrap');
    if (!wrap || !wrap.querySelector('.product-image a.pro-img .img2')) return;

    if (wrap.classList.contains('is-alt-image')) return;

    e.preventDefault();
    clearAltImages(wrap);
    wrap.classList.add('is-alt-image');
  }, { passive: false });
})();